import { Component, Input } from '@angular/core';
import { TeamlidProfiel } from '../../model/teamlid.model';
import { ParkourActionComponent, ParkourIconComponent } from '@parkour/ui';
import { ParkourProfielBlockComponent } from '../../../shared/components/parkour-profiel-block/parkour-profiel-block.component';
import { NgClass } from '@angular/common';

@Component({
  standalone: true,
  selector: 'parkour-teammember-action',
  templateUrl: './teammember-action.component.html',
  imports: [ParkourActionComponent, ParkourProfielBlockComponent, ParkourIconComponent, NgClass],
})
export class TeammemberActionComponent {
  @Input({ required: true }) public teamlid!: TeamlidProfiel;
  @Input({ required: true }) link!: string;
}
